import { useContext, useEffect, useRef, useState } from 'react';
import MenuWarehouseIngredientEdit from './MenuWarehouseIngredientEdit';
import WebUniversalNewEx, { WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { columnsheadId } from '../../universal/columnshead';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import { Button, Modal, Space, Switch, Table, Tooltip } from 'antd';
import CheckIngredient from '../ingredient/CheckIngredient';
import CopyIngredient from '../ingredient/CopyIngredient';
import SetMealIngredientEdit from '../ingredient/SetMealIngredientEdit';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';
import { SocketContext } from '../../../App';
import antMessage from '../../../utils/extend/AntdNotification';
import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';

//组件 MenuWarehouseIngredient 
export default function MenuWarehouseIngredient(props: any) {

    const ref = useRef<any>(undefined);
    const { data, closeModal } = props;
    const apiId = 'menuWarehouseIngredient';
    const notificationApi = useNotificationInstance();

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;

    //配料表窗口
    const [checkIngredientVisible, setCheckIngredientVisible] = useState(false)

    //配料表数据
    const [ingredientData, setIngredientData] = useState<any>();

    //复制窗口
    const [copyIngredientVisible, setCopyIngredientVisible] = useState(false)

    //复制数据
    const [copyIngredientData, setCopyIngredientData] = useState<any>();

    const [isAutoUpdateTableVisible, setIsAutoUpdateTableVisible] = useState(false);
    const [isAutoUpdateRows, setIsAutoUpdateRows] = useState<any>([]);

    const [currentData, setCurrentData] = useState(1);
    const [pageSizeData, setPageSizeData] = useState(10);
    const [totalData, setTotalData] = useState(0);

    /** 数据刷新中 */
    let loadings = false;

    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps            
        }

        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据

    //表头
    const isAutoUpdateColumns = [
        {
            title: 'ID',
            dataIndex: 'id',
            width: 50,
            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 6 ? text.substring(0, 6) + '....' : text)
                    : ''
            }</Tooltip>
        },

        {
            title: '菜式',
            dataIndex: 'foodName',
            render: (text: any, record: any) => {
                if (record.menuWarehouseIngredient.branchStoreMenuWarehouseSpecId) {
                    return (
                        <div>{record.menuWarehouseIngredient.branchStoreMenuWarehouse.foodName}</div>
                    )
                }
                else {
                    return (
                        <div>{record.menuWarehouseIngredient.feastTeamMenuWarehouse.foodName}</div>
                    )
                }
            }
        },
        {
            title: '规格',
            dataIndex: 'spec',
            render: (text: any, record: any) => {
                if (record.menuWarehouseIngredient.branchStoreMenuWarehouseSpecId) {
                    return (
                        <div>{record.menuWarehouseIngredient.branchStoreMenuWarehouseSpec.branchStoreMenuWarehouseSpecName}</div>
                    )
                }
                else {
                    return (
                        <div>{record.menuWarehouseIngredient.productUnit.productUnitName}</div>
                    )
                }
            }
        },
        {
            title: '原材料',
            dataIndex: 'productName',
            render: (text: any, record: any) => {
                return (
                    <div>
                        {record.product.productName}
                    </div>
                )
            }
        },
        {
            title: '自动更新',
            dataIndex: 'autoUpdate',
            render: (text: any, record: any) => {
                return (
                    <Switch checkedChildren="是" unCheckedChildren="否" checked={text} key={record.id}
                        onChange={(e) => handleAutoUpdate({
                            apiId: "menuWarehouseIngredientDetail",
                            id: record.id,
                            columnName: "autoUpdate",
                            value: e
                        })}
                    />
                )
            }
        },
    ];

    //  打开配料表页面
    const handleCheckIngredient = (record: any) => {
        // console.log(record);
        sendData.id = record.id;
        // sendData.branchStoreName = record.branchStore.branchStoreName;
        // sendData.brandName = record.branchStore.brand.brandName;
        sendData.foodName = record.branchStoreMenuWarehouseSpecId ? record.branchStoreMenuWarehouse.foodName : record.feastTeamMenuWarehouse.foodName;
        setIngredientData(sendData);
        setCheckIngredientVisible(true);
    };

    //  关闭配料表页面
    const onCloseModalCheckIngredientVisible = (state: boolean) => {
        setCheckIngredientVisible(false);
    };

    //  打开复制页面
    const handleCopyIngredient = (record: any) => {
        // console.log(record);
        sendData.type = 'COPY';
        sendData.id = record.id;
        sendData.path = data.path;
        // sendData.branchStoreName = record.branchStore.branchStoreName;
        // sendData.brandName = record.branchStore.brand.brandName;
        sendData.foodName = record.branchStoreMenuWarehouseSpecId ? record.branchStoreMenuWarehouse.foodName : record.feastTeamMenuWarehouse.foodName;
        setCopyIngredientData(sendData);
        setCopyIngredientVisible(true);
    };

    //  关闭复制页面
    const onCloseModalCopyIngredientVisible = (state: boolean) => {
        setCopyIngredientVisible(false);
    };

    const handleAutoUpdate = (apiData: any) => {
        const { apiId, id, columnName, value } = apiData;
        fetchApi.PUT(wmService, {
            apiId,
            apiVariable: id,
            apiExtend: "updateOne",
            apiData: {
                columnName,
                value
            }
        }).then(async res => {
            if (res.success) {
                antMessage('success', res.data.message, 'success');
                await refreshData();
            }
        }).catch(err => {
            showCustomNotification(notificationApi!, {
                type: 'error',
                message: "错误，无法保存",
                description: err.message + ' | status：' + err.errors.status,
            });
        })
    };

    const refreshData = () => {
        fetchApi.GET(wmService, {
            apiId,
            apiExtend: 'showIsAutoUpdate',
            apiData: {
                branchStoreId: contextData?.currentBranchStoreId,
                sendPageStr,
                current: currentData,
                pageSize: pageSizeData,
                mountDataOptions: {
                    userMount: {
                        isDept: true
                    }
                }
            }
        }).then(res => {
            if (res.success) {
                setIsAutoUpdateRows(res.data.rows);
                setCurrentData(res.data.current);
                setPageSizeData(res.data.pageSize);
                setTotalData(res.data.total);
            }
        })
    }

    /**
     * 获取数据
     * @param options 选项
     * @returns 
     */
    const getPageData = async (options?: {
        /** 当前页 */
        current?: number,
        /** 分页数量 */
        pageSize?: number,
    }) => {
        if (typeof options === 'undefined') {
            options = {};
        }

        let { current, pageSize } = options;
        current = current ? current : currentData;
        pageSize = pageSize ? pageSize : pageSizeData;
        if (loadings === true) { return }
        loadings = true;
        fetchApi.GET(wmService, {
            apiId,
            apiExtend: 'showIsAutoUpdate',
            apiData: {
                branchStoreId: contextData?.currentBranchStoreId,
                sendPageStr,
                current,
                pageSize,
                mountDataOptions: {
                    userMount: {
                        isDept: true
                    }
                }
            }
        }).then(res => {
            if (res.success === true) {
                setIsAutoUpdateRows(res.data.rows);
                setCurrentData(res.data.current);
                setPageSizeData(res.data.pageSize);
                setTotalData(res.data.total);
            }
            loadings = false;
        })
    };

    // 表格分页属性
    const paginationProps = {
        showSizeChanger: true,
        showQuickJumper: false,
        showTotal: () => `共${totalData}条`,
        pageSize: pageSizeData,
        current: currentData,
        total: totalData,
        onShowSizeChange: (current: number, pageSize: number) =>
            getPageData({ current, pageSize }),
        onChange: (current: number) =>
            getPageData({ current }),
    };

    // 打开表格(显示那些单价不自动更新的原材料)弹窗
    const isAutoUpdateTable = () => {
        setIsAutoUpdateTableVisible(true);
        refreshData();
    };

    // 关闭表格(显示那些单价不自动更新的原材料)弹窗
    const closeIsAutoUpdateTable = () => {
        setIsAutoUpdateTableVisible(false);
        setCurrentData(1);
        setPageSizeData(10);
        setTotalData(0);
    };

    //  表头
    const columnsHead = [
        {
            title: '门店',
            dataIndex: 'branchStoreName',
            render: (text: any, record: any) => {
                if (record.branchStore) {
                    return (
                        <div>{record.branchStore.brand.brandName + " " + record.branchStore.branchStoreName}</div>
                    )
                }
            }
        },
        {
            title: '菜式',
            dataIndex: 'foodName',
            render: (text: any, record: any) => {
                if (record.branchStoreMenuWarehouseSpecId) {
                    return (
                        <div>{record.branchStoreMenuWarehouse.foodName}</div>
                    )
                }
                else {
                    return (
                        <div>{record.feastTeamMenuWarehouse.foodName}</div>
                    )
                }
            }
        },
        {
            title: '规格',
            dataIndex: 'spec',
            render: (text: any, record: any) => {
                if (record.branchStoreMenuWarehouseSpecId) {
                    return (
                        <div>{record.branchStoreMenuWarehouseSpec.branchStoreMenuWarehouseSpecName}</div>
                    )
                }
                else {
                    return (
                        <div>{record.productUnit.productUnitName}</div>
                    )
                }
            }
        },
        {
            title: '售价',
            dataIndex: 'sellPrice',
        },
        {
            title: '成本价',
            dataIndex: 'costPrices',
        },
        {
            title: '毛利率',
            dataIndex: 'grossProfitRatio',
            render: (text: any, record: any) => {
                return (
                    <div>{record.grossProfitRatio + " %"}</div>
                )
            }
        },
        {
            title: '配料表',
            dataIndex: 'checkIngredient',
            key: 'checkIngredient',
            render: (text: any, record: any) =>
                <Space size="small">
                    <Button size={"small"} type="primary" onClick={() => handleCheckIngredient(record)}>配料表</Button>
                </Space>
        },

        data.path !== "MenuWarehouse" ?
            {
                title: '复制',
                dataIndex: 'copyIngredient',
                key: 'copyIngredient',
                render: (text: any, record: any) => {
                    if (record.foodType !== 'setMeal') {
                        return (
                            <Space size="small">
                                <Button size={"small"} type="primary" onClick={() => handleCopyIngredient(record)}>复制到...</Button>
                            </Space>
                        )
                    }
                }
            } : {},
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    const handleOk = (e: any) => {
        closeModal(true);
    };

    let sendPageStr: any
    if (data.path === "BranchStoreMenuWarehouse") {
        sendPageStr = {
            branchStoreId: data.branchStoreId,
            menuWarehouseId: data.menuWarehouseId ? data.menuWarehouseId : null,
            branchStoreMenuWarehouseId: data.id,
            foodName: data.foodName,
            productUnitName: data.productUnitName,
            foodType: data.foodType,
            path: data.path
        }
    }
    else {
        if (data.path === "MenuWarehouse") {
            sendPageStr = {
                menuWarehouseId: data.id,
                path: data.path
            }
        }
        else {
            sendPageStr = {
                feastTeamMenuWarehouseId: data.id,
                productUnitId: props.data.productUnitId,
                productUnitName: props.data.productUnitName,
                foodName: data.foodName,
                path: data.path
            }
        }
    }

    //  传关参数
    let sendData = {
        type: 'EDIT',
        id: '',
        // branchStoreName: '',
        // brandName: '',
        foodName: '',
        path: '',
    }

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '主配料信息',
        apiId,
        columns,
        showLogger: {
            logger: {
                id: 'ingredientOpLogger'
            },
            loggerDisplay: true,
            loggerSingleDisplay: true,
            loggerQueryType: 'ingredient',
            loggerQueryTypeExtendId: data.branchStoreId
        },
        showStates: data.path === 'MenuWarehouse' ? false : true,
        showAdd: data.path === 'MenuWarehouse' ? false : true,
        showOperation: data.path === 'MenuWarehouse' ? false : true,
        EditComponent: data.foodType === 'setMeal' ? SetMealIngredientEdit : MenuWarehouseIngredientEdit,
        sendPageData: sendPageStr,
        mountDataOptions: {
            userMount: {
                isDept: true
            }
        }
    };

    return (
        <>
            <AntDraggableModal
                title={'主配料'}
                open={true}
                okText='关闭'
                // cancelText={stringHandle.isUndefined()}
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={handleOk}
                closable={false}
                maskClosable={false}
                width={1000}>
                <div>
                    <Modal
                        zIndex={1000}
                        title={"单价不自动更新的原材料"}
                        open={isAutoUpdateTableVisible}
                        closable={false}
                        onOk={closeIsAutoUpdateTable}
                        okText={"关闭"}
                        cancelButtonProps={{ style: { display: "none" } }}
                        width={800}
                    >
                        <Table
                            pagination={paginationProps}
                            rowKey={(record: any) => record.id}
                            columns={isAutoUpdateColumns}
                            dataSource={isAutoUpdateRows}
                        >
                        </Table>
                    </Modal>
                </div>
                {
                    data.path !== "MenuWarehouse"
                        ? (<Button type="primary" onClick={isAutoUpdateTable}>单价不自动更新的原材料</Button>)
                        : null
                }
                &nbsp;&nbsp;&nbsp;&nbsp;
                <WebUniversalNewEx props={extendProps} ref={ref} ></WebUniversalNewEx>
            </AntDraggableModal>

            {checkIngredientVisible
                ? (<CheckIngredient
                    closeModal={onCloseModalCheckIngredientVisible} data={ingredientData} />)
                : null}

            {copyIngredientVisible
                ? (<CopyIngredient
                    closeModal={onCloseModalCopyIngredientVisible} data={copyIngredientData} />)
                : null}
        </>
    )
}